import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
import checkedUrl from '@/assets/icons/checkbox_checked.png'
import checkedDisabledUrl from '@/assets/icons/checkbox_checked_disabled.png'
import checkedReadOnlyUrl from '@/assets/icons/checkbox_checked_readonly.png'
import partialUrl from '@/assets/icons/checkbox_partial.png'
import uncheckedUrl from '@/assets/icons/checkbox_unchecked.png'
import uncheckedDisabledUrl from '@/assets/icons/checkbox_unchecked_disabled.png'
import uncheckedReadOnlyUrl from '@/assets/icons/checkbox_unchecked_readonly.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["update:checked"],
  setup(__props: any, { emit }) {

const props = __props;





const iconUrlRef = computed(() => {
  if (props.disabled) {
    return props.checked ? checkedDisabledUrl : uncheckedDisabledUrl
  }
  if (props.readonly) {
    return props.checked ? checkedReadOnlyUrl : uncheckedReadOnlyUrl
  }
  if (props.checked == undefined) {
    return partialUrl
  }
  return props.checked ? checkedUrl : uncheckedUrl
})

function onClick() {
  if (!props.disabled && !props.readonly) {
    emit('update:checked', !props.checked)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "checkbox",
    src: iconUrlRef.value,
    role: "checkbox",
    tabindex: "0",
    onClick: onClick
  }, null, 8, _hoisted_1))
}
}

})